import * as React from 'react';
import { PropertyListingBadgeModel } from 'models';
import { UitkBadge, UitkBadgeTheme } from 'uitk-react-badge';

interface RenderBadgeProps {
  propertyListingBadgeModel: PropertyListingBadgeModel;
  travelAd: {
    impressionTrackingUrl: string;
  };
  displaySecondaryBadge: boolean;
}

export const TitleBadge: React.FunctionComponent<RenderBadgeProps> = ({ propertyListingBadgeModel, travelAd, displaySecondaryBadge }) => {
  const { primary, secondary } = { ...propertyListingBadgeModel };
  const { impressionTrackingUrl } = { ...travelAd };

  return (
    <React.Fragment>
      {primary &&
        (primary.text || primary.icon) && (
          <UitkBadge
            className="title__badge all-t-margin-two"
            icon={primary.icon}
            text={primary.text}
            theme={UitkBadgeTheme[primary.theme]}
          />
        )}
      {displaySecondaryBadge &&
        secondary &&
        (secondary.text || secondary.icon) && (
          <UitkBadge theme={UitkBadgeTheme[secondary.theme]} text={secondary.text} className="title__badge title__badge-details" />
        )}
      {impressionTrackingUrl && (
        <img
          className="listing__travel-ad-impression-pixel"
          src={impressionTrackingUrl}
          alt=""
          data-stid="travel-ad-impression-pixel"
          style={{ display: 'none' }}
        />
      )}
    </React.Fragment>
  );
};
TitleBadge.displayName = 'TitleBadge';
